// extracted by mini-css-extract-plugin
export default {"gpt3__brand":"brand_gpt3__brand__RT0G+"};